module.exports = __webpack_public_path__ + "static/media/favoriteEmpty.53290efb.svg";